const getBaseUrl = (envVar: string | undefined): string => {
  if (envVar) {
    return envVar;
  }
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }
  throw new Error(
    `Environment variable is missing and window is not available. Please set the required environment variable.`
  );
};

const buildEndpoint = (baseUrl: string, path: string): string => {
  const base = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
  const endpointPath = path.startsWith('/') ? path : `/${path}`;
  return `${base}${endpointPath}`;
};

export const Endpoint = {
  GRAPHQL_EDUSSON_AI_TOOL: buildEndpoint(
    getBaseUrl(process.env.REACT_APP_PARENT_DOMAIN_LINK),
    '/graphql/ai_tool'
  ),
  GRAPHQL_EDUSSON_FORM: buildEndpoint(
    getBaseUrl(process.env.REACT_APP_PARENT_DOMAIN_LINK),
    '/graphql/front'
  ),
  GRAPHQL_WRITING_TOOLS_AI_CALL: `${process.env.REACT_APP_WRITING_TOOLS_API_HOST}/graphql/ai_call`,
  DOWNLOAD_PDF_FILE: `${process.env.REACT_APP_WRITING_TOOLS_API_HOST}/ai_download_file_pdf_direct_text_ko1`,
};
